import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import { AppContext } from 'contexts';
import { validateAdminToken } from 'utils';

const useStyles = makeStyles({
  reviewer: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    color: '#fff',
    textTransform: 'capitalize',
    border: '1px solid #fff',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    marginLeft: 10,
    padding: '3px 16px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    '&:first-child': {
      marginLeft: 0,
    },
  },
  rejected: {
    color: 'white',
    backgroundColor: 'red',
    '&:hover': {
      backgroundColor: 'rgba(255, 115, 115, 1)',
    },
  },
  accepted: {
    color: 'white',
    backgroundColor: 'green',
    '&:hover': {
      backgroundColor: 'lightGreen',
    },
  },
});

function Reviewer() {
  const classes = useStyles();

  const appContext = useContext(AppContext);
  const { adminToken, currentRoom, currentMarkerIndex, setMarkerState } = appContext;

  const [hasAdminToken, setHasAdminToken] = useState(false);

  const currentMarker = currentRoom?.markers?.[currentMarkerIndex];
  const currentMarkerState = currentMarker?.state || 0;

  const displayState = currentMarkerState;

  useEffect(() => {
    if (!adminToken) return;

    const checkToken = () => {
      validateAdminToken(adminToken).then((result: boolean) => {
        setHasAdminToken(result);
      });
    };

    checkToken();
  }, [adminToken]);

  if (!hasAdminToken) return null;

  const onAccept = () => {
    setMarkerState(true);
  };

  const onReject = () => {
    setMarkerState(false);
  };

  return (
    <div className={classes.reviewer}>
      <Button
        className={classNames(classes.button, displayState === 1 ? classes.accepted : '')}
        onClick={onAccept}
        onTouchEnd={onAccept}
      >
        <Typography>Visible</Typography>
      </Button>
      <Button
        className={classNames(classes.button, displayState === 2 ? classes.rejected : '')}
        onClick={onReject}
        onTouchEnd={onReject}
      >
        <Typography>Cachée</Typography>
      </Button>
    </div>
  );
}

export default Reviewer;
